import { Checkbox, Modal } from '@mantine/core';
import { IconShieldLock } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, InputField } from '../../../../../components/Atoms';

interface NewPasswordRevealModalProps {
    opened: boolean;
    newPassword: string;
    onClose: () => void;
}

export default function NewPasswordRevealModal({
    opened,
    newPassword,
    onClose,
}: NewPasswordRevealModalProps) {
    const { t } = useTranslation('artifactRegistry');
    const [acknowledged, setAcknowledged] = useState(false);

    useEffect(() => {
        if (!opened) {
            setAcknowledged(false);
        }
    }, [opened]);

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            centered
            size="lg"
            withCloseButton={false}
            closeOnClickOutside={false}
            closeOnEscape={false}
            title={
                <div className="inline-flex items-center gap-2">
                    <IconShieldLock size={20} />
                    <span className="font-semibold">
                        {t('auth.reveal.title', 'Save your new password')}
                    </span>
                </div>
            }
        >
            <div className="w-full flex flex-col gap-4">
                <div className="w-full p-3 rounded-sm bg-[#3a1c1c] border border-[#eb5757]/40 text-sm text-[#ffb3b3] light:bg-red-100 light:border-red-300 light:text-red-800">
                    {t(
                        'auth.reveal.banner',
                        'This password will not be shown again. Copy it now and store it somewhere safe.'
                    )}
                </div>

                <InputField
                    readOnly
                    size="md"
                    label={t('auth.reveal.password', 'New password')}
                    type="text"
                    value={newPassword}
                    placeholder={newPassword}
                    showCopy
                />

                <Checkbox
                    color="indigo"
                    checked={acknowledged}
                    onChange={(e) => setAcknowledged(e.currentTarget.checked)}
                    label={t('auth.reveal.acknowledge', "I've saved this password somewhere safe.")}
                />

                <div className="w-full flex flex-row justify-end items-center gap-2">
                    <Button variant="primary" onClick={onClose} disabled={!acknowledged}>
                        {t('auth.reveal.close', 'Close')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
